import {
  Required,
  Schema,
  TextField,
  RemoteDataSource,
  ForeignKeyField,
  DynamicColumn
} from "lego-gui-lib/lib";
import { mainStore, api } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { Auth } from "../../core/model/auth";

export const NetworkOperatorSchema = new Schema<DynamicColumn>({
  fields: [
    {
      name: "name",
      title: t("common:name"),
      type: TextField(Required)
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ADMIN,
    editableRole: Auth.Roles.ADMIN
  }
});

mainStore.networkOperator = RemoteDataSource.create({
  api: api,
  name: "networkOperator",
  schema: NetworkOperatorSchema,
  url: "/networkOperators",
  commons: mainStore.commons
});

mainStore.networkOperatorFk = RemoteDataSource.clone(mainStore.networkOperator);

export const NetworkOperatorFK = ForeignKeyField({
  dataSource: mainStore.networkOperatorFk.listDataSource,
  labelField: "name",
  valueField: "id",
  minWidth: 70
});
